import { useNavigate } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { createCustomer } from "../../helpers/http_customers_requests";
import { brazilian_states } from "../../data/general_variables";
import { useQuery } from "@tanstack/react-query";
import { getPriceGroups } from "../../helpers/http_price_groups_requests";

export default function CustomerNew() {

    const navigate = useNavigate();

    const formatOptions = (data) => data?.data?.data?.data?.map(item => ({ value: item.id, label: item.name + ` (18K: ${item.high_gold_index} e 10K: ${item.low_gold_index})` }));

    const priceGroupsQuery = useQuery({ queryKey: ['getPriceGroups'], queryFn: getPriceGroups, staleTime: 1000 * 5 });

    const priceGroups = formatOptions(priceGroupsQuery);

    const formFieldList = [
        {
            title: "Dados de Fiscais",
            fields: [
                {
                    name: "complete_name",
                    label: "Nome Completo",
                    type: "text",
                    required: true,
                },
                {
                    name: "cnpj",
                    label: "CNPJ",
                    type: "text",
                    mask: "cpf_cnpj",
                    required: true,
                },
                {
                    name: "state_registration",
                    label: "Inscrição Estadual",
                    type: "number",
                },
                {
                    name: "social_reason",
                    label: "Razão Social",
                    type: "text",
                    required: true,
                },
                {
                    name: "whatsapp_number",
                    label: "Número de Whatsapp",
                    type: "text",
                    mask: "phone",
                    required: true,
                },
                {
                    name: "email",
                    label: "E-mail Institucional",
                    type: "text",
                    required: true,
                },
                {
                    name: "price_group",
                    label: "Grupo de Índices",
                    type: "select",
                    required: true,
                    options: priceGroups
                },
                {
                    name: "observation",
                    label: "Observação",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                }
            ]
        },
        {
            title: "Dados do Responsável Geral",
            fields: [
                {
                    name: "main_manager",
                    label: "Nome completo",
                    type: "text",
                    required: true,
                },
                {
                    name: "main_manager_contact",
                    label: "Número de Whatsapp",
                    type: "text",
                    mask: "phone",
                    required: true,
                },
            ]
        },
        {
            title: "Dados do Responsável Financeiro",
            fields: [
                {
                    name: "financial_manager",
                    label: "Nome completo",
                    type: "text",
                    required: true,
                },
                {
                    name: "financial_manager_contact",
                    label: "Número de Whatsapp",
                    type: "text",
                    mask: "phone",
                    required: true,
                },
            ]
        },
        {
            title: "Endereço",
            fields: [
                {
                    name: "zip_code",
                    label: "CEP",
                    type: "text",
                    mask: "zipcode",
                    required: true,
                },
                {
                    name: "address",
                    label: "Endereço",
                    type: "text",
                    required: true,
                },
                {
                    name: "address_number",
                    label: "Número",
                    type: "text",
                    required: true,
                },
                {
                    name: "complement",
                    label: "Complemento",
                    type: "text",
                },
                {
                    name: "neighborhood",
                    label: "Bairro",
                    type: "text",
                    required: true,
                },
                {
                    name: "city",
                    label: "Cidade",
                    type: "text",
                    required: true,
                },
                {
                    name: "state",
                    label: "Estado",
                    type: "select",
                    required: true,
                    options: brazilian_states
                }
            ]
        },

    ];

    const handleSubmit = (data) => {
        createCustomer(data, () => navigate('/clientes'))
    };

    return <DynamicFormPage title={"Clientes - Cadastro"} onSubmit={handleSubmit} formFieldList={formFieldList} avatarUpload onCancel={() => navigate(-1)} />;
};
